import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    MenuItem,
    Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { CustomTextField } from '../Textfield';
import { connect } from 'react-redux';
import { updateLeadStatus } from '../../store/actions/leadActionCreator';
import { isDigilockerVerified } from '../../utils/appHelper';
import { fetchBasicLeadkyc } from '../../store/actions/leadActionCreator';

// Predefined issue reasons per document type. "Other" (and any doc type not
// listed here) falls back to a free-text reason field.
const SELFIE_ISSUE_REASONS = [
    'Not clear / blurry',
    'Old photo, upload latest',
    'Incomplete / cut off',
    "Selfie doesn't match the ID",
];
const AADHAR_ISSUE_REASONS = [
    'Not clear / blurry',
    'Incomplete / cut off',
    'Wrong document uploaded',
    'Aadhaar & PAN details differ',
];
const PAN_ISSUE_REASONS = [
    'Not clear / blurry',
    'Incomplete / cut off',
    'Wrong document uploaded',
    'Aadhaar & PAN details differ',
];

const getReasonOptions = (docName) => {
    const normalized = docName?.toLowerCase?.() ?? '';
    if (normalized.includes('selfie') || normalized.includes('profile picture')) {
        return SELFIE_ISSUE_REASONS;
    }
    if (normalized.includes('aadhar') || normalized.includes('aadhaar')) {
        return AADHAR_ISSUE_REASONS;
    }
    if (normalized.includes('pan')) {
        return PAN_ISSUE_REASONS;
    }
    return null;
};

function ReasonField({ item, value, onChange }) {
    const options = getReasonOptions(item);
    if (!options) {
        return (
            <CustomTextField
                fullWidth={true}
                label="Reason"
                variant="outlined"
                id="reason"
                name="reason"
                value={value ?? ''}
                onChange={onChange}
                error={!value}
            />
        );
    }
    return (
        <CustomTextField
            select
            fullWidth={true}
            label="Reason"
            variant="outlined"
            id="reason"
            name="reason"
            value={value ?? ''}
            onChange={onChange}
            error={!value}
        >
            {options.map((opt) => (
                <MenuItem key={opt} value={opt}>
                    {opt}
                </MenuItem>
            ))}
        </CustomTextField>
    );
}

function InCompleteHireModal({
    leadInfo,
    open,
    onClose,
    defaultValue = {},
    markIncompleteHireList,
    dispatchUpdateLeadStatus,
    dispatchFetchBasicLeadkyc,
    ...props
}) {
    const [isOpen, toggleModal] = useState(open);
    const [kycInfo, setKycInfo] = useState({});
    const [loading, toggleLoading] = useState(false);
    const [reason, setReason] = useState({});
    const [markIncompleteDocList, setMarkIncompleteDocList] = useState([]);
    const [checkList, setCheckList] = useState({});
    const fetchKycInfo = async () => {
        await toggleLoading(true);
        dispatchFetchBasicLeadkyc(
            leadInfo.id,
            (resp) => {
                toggleLoading(false);
                let values = {
                    ...resp?.response,
                    dob: !!resp?.response?.dob ? resp?.response?.dob : null,
                };
                setKycInfo(values);
            },
            (resp) => {
                toggleLoading(false);
            },
        );
    };
    const handleClose = (values) => {
        toggleModal(!isOpen);
        onClose && onClose(values);
    };

    const markInComplete = () => {
        toggleLoading(true);
        const payload = {
            status: 'Incomplete',
            comments: '',
            incompleteHireReasonList: Object.keys(checkList)
                ?.filter((i) => !!checkList[i])
                ?.map((i) => ({
                    name: i,
                    reason: reason[i],
                })),
        };
        dispatchUpdateLeadStatus(
            leadInfo.id,
            payload,
            (resp) => {
                toggleLoading(false);
                handleClose('');
            },
            (err) => {
                toggleLoading(false);
                handleClose('');
            },
        );
    };

    useEffect(() => {
        if (isOpen && leadInfo?.id) {
            fetchKycInfo();
        }
    }, [isOpen, leadInfo]);

    useEffect(() => {
        let list = markIncompleteHireList?.split(',') ?? [];
        setMarkIncompleteDocList(list);
    }, [markIncompleteHireList]);

    const isButtonDisbled = Object.keys(checkList)
        ?.filter((i) => !!checkList[i])
        ?.map((i) => !!reason[i]);
    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className={`cancelButton`}
            onClick={() => handleClose(defaultValue)}
            style={{
                boxShadow: 'none',
            }}
            disableElevation
        >
            Cancel
        </Button>,
        <Button
            key={2}
            variant="contained"
            color="primary"
            className={`saveButton`}
            type="submit"
            onClick={markInComplete}
            style={{
                boxShadow: 'none',
            }}
            disabled={
                !isButtonDisbled?.length || isButtonDisbled.includes(false)
            }
            disableElevation
        >
            Incomplete
        </Button>,
    ];
    let isAadhaarVerifiedByDigiLocker = isDigilockerVerified(
        kycInfo?.aadhar ?? {},
    );
    let isPanVerifiedByDigiLocker = isDigilockerVerified(
        kycInfo?.panCard ?? {},
    );
    let filteredList = markIncompleteDocList;
    /*if (!!isAadhaarVerifiedByDigiLocker) {
        filteredList = filteredList?.filter((item) =>
            [
                'Aadhaar',
                'AADHAAR',
                'aadhaar',
                'Aadhar',
                'AADHAR',
                'aadhar',
            ].includes(item)
                ? false
                : true,
        );
    }
    if (!!isPanVerifiedByDigiLocker) {
        filteredList = filteredList.filter((item) =>
            ['PAN', 'Pan', 'pan', 'Pan Card', 'PAN CARD', 'pan card'].includes(
                item,
            )
                ? false
                : true,
        );
    }*/
    return (
        <Modal
            onClose={() => handleClose(defaultValue)}
            open={isOpen}
            title={`Mark Incomplete`}
            actions={actions}
            loading={loading}
            isForm={false}
        >
            <Typography
                style={{
                    fontSize: '18px',
                    fontWeight: 600,
                }}
            >
                Select Document which have issue
            </Typography>
            <FormGroup>
                {[...filteredList]?.map((item) => (
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name={item}
                                    checked={checkList[item]}
                                    onChange={(event) => {
                                        setCheckList({
                                            ...checkList,
                                            [event.target.name]:
                                                event.target.checked,
                                        });
                                        !!reason[item] &&
                                            setReason({
                                                ...reason,
                                                [item]: event.target?.nodata,
                                            });
                                    }}
                                    color="primary"
                                />
                            }
                            label={item}
                        />
                        {!!checkList[item] && (
                            <ReasonField
                                item={item}
                                value={reason[item]}
                                onChange={(event) => {
                                    setReason({
                                        ...reason,
                                        [item]: event.target.value,
                                    });
                                }}
                            />
                        )}
                    </>
                ))}
            </FormGroup>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    markIncompleteHireList: state?.user?.config?.markIncompleteHireList,
});
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateLeadStatus: (id, data, onSuccess, OnFailed) =>
        dispatch(updateLeadStatus(id, data, onSuccess, OnFailed)),

    dispatchFetchBasicLeadkyc: (id, data, onSuccess, OnFailed) =>
        dispatch(fetchBasicLeadkyc(id, data, onSuccess, OnFailed)),
});



const InCompleteHireModalConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(InCompleteHireModal);

function InCompleteHireModalWrapper(props) {
    return <InCompleteHireModalConnected {...props} />;
}
export default InCompleteHireModalWrapper;
